module.exports = __webpack_public_path__ + "fonts/baronsans-bolditalic-webfont.7b3729f6.woff";